module.exports = __webpack_public_path__ + "img/petstairs49.4f21a974.jpg";